export const Login = {
  forgotPassword: 'Esqueceu-se da sua palavra-chave?',
  notHaveAccount: 'Ainda não tem conta?',
  register: 'Registe-se',
  warning: 'Ocorreu um erro ao iniciar a sua sessão. Queira repetir.'
}



// WEBPACK FOOTER //
// ./src/translations/pt/views/Login.js